import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useModal } from '../context/ModalContext';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { DottedSurface } from './ui/dotted-surface';

const CTA = () => {
  const { openDemoModal } = useModal();
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative py-20 sm:py-24 lg:py-32 bg-[--bg-primary]">
      <div className="absolute top-0 left-0 right-0 section-divider" />
      
      <div ref={sectionRef} className="max-w-[1500px] mx-auto px-4 sm:px-6">
        <div className="relative overflow-hidden soft-card rounded-3xl p-8 md:p-10 lg:p-14 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <DottedSurface className="opacity-45 [mask-image:radial-gradient(circle_at_70%_40%,black_15%,transparent_72%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_30%,var(--accent-glow)_0%,transparent_45%)]" />

          {/* Text */}
          <div 
            className={`relative z-10 transition-all duration-700 ease-out ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
          >
            <p className="section-eyebrow mb-4">
              Start building
            </p>
            <h2 className="text-[clamp(2rem,4vw,3.8rem)] font-semibold text-[--text-primary] leading-[1.02]">
              See what's leaking in your operations.
            </h2>
            <p className="mt-5 max-w-3xl text-base leading-relaxed text-[--text-secondary]">
              Free AI Audit. 60 minutes. No commitment. You walk away with a prioritized opportunity report and the replacement math — whether or not we work together.
            </p>
          </div>

          {/* CTA Button */}
          <button 
            onClick={openDemoModal}
            className={`relative z-10 px-8 py-4 text-[11px] font-medium text-[--bg-primary] uppercase tracking-[0.18em] font-mono bg-[--accent] rounded-full hover:bg-[--accent-hover] transition-all flex items-center gap-3 btn-pattern self-start lg:self-auto ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
            style={{ transitionDelay: '200ms', transitionDuration: '700ms' }}
          >
            Book a Free Audit
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
